import React, { createContext, useContext, useState } from "react";
import useStateCallback from "../hooks/useStateCallback";

export const BikunContext = createContext({});

export const useBikunContext = () => useContext(BikunContext);

export const BikunContextProvider = ({ children }) => {
  const defaultHalte = {
    name: "",
    value: "",
  };

  const defaultJalur = {
    num: 0,
    name: "",
  };

  const [dataBikun, setDataBikun] = useStateCallback([]);
  const [choosenHalte, setChoosenHalte] = useState(defaultHalte);
  const [choosenJalur, setChoosenJalur] = useState(defaultJalur);

  const updateDataBikun = (state, cb) => {
    setDataBikun(state, cb);
  };

  const updateChoosenHalte = (value) => {
    setChoosenHalte(value);
  };

  const updateChoosenJalur = (value) => {
    setChoosenJalur(value);
  };

  const resetHalteJalur = () => {
    setChoosenHalte(defaultHalte);
    setChoosenJalur(defaultJalur);
  };

  const value = {
    dataBikun,
    setDataBikun,
    choosenHalte,
    setChoosenHalte,
    choosenJalur,
    setChoosenJalur,
    updateDataBikun,
    updateChoosenHalte,
    updateChoosenJalur,
    resetHalteJalur,
  };

  return (
    <BikunContext.Provider value={value}>{children}</BikunContext.Provider>
  );
};
